import { addDaysToISODate } from './addDaysToISODateString'

export function todayPlusDaysISODateString(numDays: number) {
  const todayString = new Date().toISOString()
  return addDaysToISODate(todayString, numDays)
}
